import {
    registerFormInputComponent,
} from '@vendure/admin-ui/core';
import { ErpSettingsFormComponent } from './components/erp-integrations-settings-form.component';
import { ErpLingXingLogisticsSettingFormComponent } from './components/erp-lingxing-logistics-setting-form.component';

export default [
    registerFormInputComponent('erp-integrations-settings-form', ErpSettingsFormComponent),
    registerFormInputComponent('erp-lingxing-logistics-setting-form', ErpLingXingLogisticsSettingFormComponent),
];
